import styled from "styled-components";

export const StyledSchedulerDashboard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  padding: 0 10px;
`;

export const StyledTasks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const StyledBottomCta = styled.div`
  position: absolute;
  right: 40px;
  bottom: 50px;
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
`;